<template lang="html">

  <section class="popup-observaciones row-center">


    <div class="contenedor-popup-observaciones" :style="styles.backgroundWhite">

      <a class="cerrar -small" title="Salir" @click="cerrar">✕</a>

      <!-- TITULO/ASUNTO -->
      <div class="contenedor-input">          
        <label for="">Titulo/asunto*</label>
        <input type="text" :style="styles.input_black" v-model="data.titulo" name="tituloObservacion" v-validate="'required'">
        <span class='error' v-if="clicked">{{ errors.first('tituloObservacion') }}</span>
      </div>
      
      <div class="contenedor-input">
        <!-- OBSERVACION -->
        <label for="">Observación*</label>
        <textarea focus="true" :style="styles.textarea" v-model="data.observacion" name="observacion" v-validate="'required'"></textarea>
        <span class='error' v-if="clicked">{{ errors.first('observacion') }}</span>
      </div>
      
      <div class="contenedor-input">
        <!-- ADJUNTO -->
        <label for="">Adjunto</label>
        <div class="dropzone row-start">

          <div class="text row-start">
            <span class="upload-icon-wrapper">
              <upload-icon v-if="!!!data.fichero.ficheroB64" class="tag-icon"></upload-icon>
              <success-icon v-else></success-icon>
            </span>
            <p v-if="!!!data.fichero.ficheroB64" :style="styles.colorMediumBlack">Arrasta tu archivo o haz click para adjuntar</p>
            <p v-else :style="styles.colorMediumBlack">{{nombreArchivo}}</p>
          </div>

          <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event)" v-validate="`size:20000000`" :class="[{'has-error' : errors.has('file')}]"/>
        </div>
      </div>

      <a class="btn" :style="styles.solidPrimary" @click="guardar" :loading="loading">Guardar</a>

    </div>
    
    <section class="popup-observaciones row-center" v-if="errorExtensionNoAdmitida">
      <div class="contenedor-popup-observaciones" :style="styles.backgroundWhite">
        
        <label>La extensión del adjunto no está admitida.</label><br><br>
        <a class="btn" :style="styles.solidPrimary" @click="errorExtensionNoAdmitida = false">Aceptar</a>
      </div>
    </section>

  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import uploadicon from '@/components/parts/icons/upload';
  import successicon from '@/components/parts/icons/success';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  export default  {
    name: 'observaciones',
    props: ['id'],
    components : {
      'upload-icon' : uploadicon,
      'success-icon' : successicon
    },
    mounted (){
      
    },
    data (){
      return {
        nombreArchivo : '',
        loading : false,
        data : {
          idPractica : '',
          titulo : '',
          observacion : '',
          fichero : {
            ficheroB64 : '',
            extension_adjunto : ''
          }
        },
        formatosPermitidos : ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/pdf','application/msword','image/*',
        '.csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
        clicked : false,
        errorExtensionNoAdmitida: false
      }
    },
    computed:{
      ...mapGetters({
        styles : 'getStyles'
      }),
    },
    methods : {
      ...mapActions([
        'annadirObservacionTutor'
      ]),
      handleFileUpload(event){

        let file = event.target.files[0];

        if (file != null){

          var mimeType = file.type;
          var extension = file.name.split(".")[1];
          
          if (this.formatosPermitidos.includes(mimeType) || extension == "msg" || extension == "eml" || mimeType == "image/jpeg" || mimeType == "image/jpg" || mimeType == "image/png"){
            this.nombreArchivo = file.name;

            this.data.fichero.extension_adjunto = file.type.split("/")[1];
            if (extension == "msg") this.data.fichero.extension_adjunto = extension

            this.getBase64(file).then(data => {
              this.data.fichero.ficheroB64 = data;
            });
          } else {
            this.errorExtensionNoAdmitida = true;
          }

        }

     },
     getBase64: function(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    cerrar : function(){
      this.$emit('cerrar');
    },
    guardar : function(){
      this.clicked = true;
      this.$validator.validateAll().then(itsOk => {
        if(itsOk){
          this.loading = true;
          this.annadirObservacionTutor(this.data).then(r => {
            this.loading = false;
            if(r){
              this.$emit('observacionAnnadida');
              this.cerrar();
            }else{
              this.loading = false;
            }
          }).catch(e =>{
            this.loading = false;
          });
        }
      });
    }
  }

}
</script>

<style scoped lang="scss">
  .popup-observaciones {
  	width: 100%;
  	position: fixed;
  	bottom: 0;
  	left: 0;
    top: 0;
    right: 0;
    height:auto;
    background: rgba(0,0,0,.9);
    padding: 50px 15px;
    z-index: 20;
  }

  .contenedor-popup-observaciones{
    padding: 50px;
    position: relative;
    max-width: 700px;
    max-height: 100%;
    overflow: scroll;
  }
  
  textarea{
    padding: 10px;
  }

  p{
    text-align: left;
    font-size: 14px;
    display: inline-block;
    margin-bottom: 20px;
    width: 100%;
    display: inline-block;
    line-height: 18px;
    
    strong{
      font-weight: 800;
    }

  }

  .dropzone{
    width: 100%;
    min-height: 50px;
    background: #f2f2f2;
    padding: 20px;
    position: relative;
  }

  .dropzone svg{
    width: 30px;
    height: 30px;
    filter: grayscale(1);
    opacity: .5
  }

  .dropzone input{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }

  .dropzone .text{
    width: 100%;
  }

  .dropzone p{
    text-align: center;
    font-size: 14px;
    color: #333;
    margin-left: 20px;
    margin-bottom: 0;
    width: auto;
  }

  .dropzone span.error{
    bottom: -24px;
  }

  label{
    margin-bottom: 10px;
  }

  .contenedor-input.-select p{
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/parts/popup-observacion-tutor.vue